import React from "react"
import ReactDOM from "react-dom"
import App from "./App" // Import the main App component
import "bootstrap/dist/css/bootstrap.min.css" // Import Bootstrap for styling
import "./styles.css" // Import your custom styles

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root") // Render the App component into the <div id="root"> in index.html
)
